import api from '../../api';
import {filter, chain, includes} from 'lodash';

export default {
    state: {
        list: [],
    },

    mutations: {
        setCases(state, data) {
            state.list = chain(state.list).concat(data).uniqBy('id').value();
        },
    },

    actions: {
        fetchModuleData() {

        },

        fetchCasesByIds({commit, state}, ids) {
            api.get('cases/', {
                params: {
                    include: ids,
                    orderby: 'include',
                    per_page: 40
                }
            })
            .then(function (response) {
                commit('setCases', response.data);
            });
        },
    },

    getters: {
        getCases(state) {
            return () => {
                return state.list;
            };
        },

        getCasesByIds(state) {
            return (ids) => {
                return filter(state.list, function(item) {
                    return includes(ids, item.id);
                });
            };
        },
    },
};